module.exports = __webpack_public_path__ + "static/media/basura.182c0835.png";